import { TableCell, Checkbox } from "@mui/material";
import type { childPartV1, childPartV2 } from "@/api/breakdownService";

interface ChildPartDataProps {
  version: "v1" | "v2";
  row: childPartV1 | childPartV2;
  processCount?: number;
  isSelected: boolean;
  onSelectChange: (row: childPartV2, checked: boolean) => void;
  isAdding: boolean;
  isEditing: boolean;
}

const ChildPartData = ({
  version,
  row,
  processCount,
  isSelected,
  onSelectChange,
  isAdding,
  isEditing,
}: ChildPartDataProps) => {
  return (
    <>
      <TableCell
        sx={{
          position: "sticky",
          left: 0,
          zIndex: 101,
          width: 70,
          minWidth: 70,
          maxWidth: 70,
          textAlign: "center",
          backgroundColor: "white",
          borderRight: "1px solid #e0e0e0",
        }}
        rowSpan={processCount || 1}
      >
        <Checkbox
          disabled={version === "v1" || isAdding || isEditing}
          checked={isSelected}
          onChange={(e) => onSelectChange(row as childPartV2, e.target.checked)}
        />
      </TableCell>
      <TableCell
        sx={{
          position: "sticky",
          zIndex: 101,
          left: 70,
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          backgroundColor: "white",
          borderRight: "2px solid #e0e0e0",
          padding: 1,
          fontWeight: "500",
          fontSize: "0.9rem",
        }}
        rowSpan={processCount || 1}
      >
        {row.child_part_no}
      </TableCell>
      <TableCell
        sx={{
          position: "sticky",
          zIndex: 101,
          left: 220,
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          backgroundColor: "white",
          borderRight: "2px solid #e0e0e0",
          padding: 1,
          fontWeight: "500",
          fontSize: "0.9rem",
        }}
        rowSpan={processCount || 1}
      >
        {row.child_part_name}
      </TableCell>
    </>
  );
};

export default ChildPartData;
